"use client"

import { StyledLink } from "@/components/styled-link"
import { getPrimaryCanonicalUrl } from "@/libs/primary-canonical-url"
import Link from "next/link"
import { usePathname } from "next/navigation"

export function AboutLink() {
  const pathname = usePathname()

  const isHome = pathname === "/"

  if (isHome) {
    return (
      <StyledLink as="button">
        <Link
          href={getPrimaryCanonicalUrl("/about-simon-betton-software-engineer")}
          title="Learn more about me "
        >
          <span className="text-neutral-800 dark:text-white">About me &rarr;</span>
        </Link>
      </StyledLink>
    )
  }

  return (
    <StyledLink as="button">
      <Link href="/" title="Learn more about me ">
        <span className="text-neutral-800 dark:text-white">&larr; Back to home</span>
      </Link>
    </StyledLink>
  )
}
